export default __webpack_public_path__ + "static/media/numero-cupom-modelo.e005ad1c.png";